import { render } from "./CompanyForm.vue?vue&type=template&id=30c0063a&scoped=true&ts=true"
import script from "./CompanyForm.vue?vue&type=script&lang=ts"
export * from "./CompanyForm.vue?vue&type=script&lang=ts"

import "./CompanyForm.vue?vue&type=style&index=0&id=30c0063a&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c0063a"]])

export default __exports__